// Language switcher (PT / EN / ES). Links to the equivalent page in
// each locale so switching keeps you on the same content. `page` is the
// locale-agnostic suffix ("" for home, "privacy", ...).

import { Link } from "react-router-dom";

import {
  LOCALES,
  LOCALE_LABELS,
  localePath,
  type PageKey,
} from "@/i18n/config";
import { useLocale } from "@/i18n/LocaleProvider";

export function LangSwitcher({
  page = "",
  className = "",
}: {
  page?: PageKey | "";
  className?: string;
}) {
  const current = useLocale();
  return (
    <div className={"flex items-center gap-1 font-mono text-[11px] " + className}>
      {LOCALES.map((loc, i) => (
        <span key={loc} className="flex items-center gap-1">
          {i > 0 && <span className="text-dim">/</span>}
          <Link
            to={localePath(loc, page)}
            className={
              loc === current
                ? "text-accent no-underline"
                : "text-muted hover:text-content no-underline"
            }
            aria-current={loc === current ? "true" : undefined}
          >
            {LOCALE_LABELS[loc]}
          </Link>
        </span>
      ))}
    </div>
  );
}
